/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Already_InvitedInputs */

const en_us2_invite_already_invited = /** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account already came by someone else's invite.`)
};

const pt_br2_invite_already_invited = /** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta já entrou pelo convite de outra pessoa.`)
};

const pt_pt2_invite_already_invited = /** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta já entrou pelo convite de outra pessoa.`)
};

/** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */
const es_419_invite_already_invited = en_us2_invite_already_invited;

/** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */
const fr_fr2_invite_already_invited = en_us2_invite_already_invited;

/** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */
const de_de2_invite_already_invited = en_us2_invite_already_invited;

/** @type {(inputs: Invite_Already_InvitedInputs) => LocalizedString} */
const it_it2_invite_already_invited = en_us2_invite_already_invited;

/**
* | output |
* | --- |
* | "Your account already came by someone else's invite." |
*
* @param {Invite_Already_InvitedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_already_invited = /** @type {((inputs?: Invite_Already_InvitedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Already_InvitedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_already_invited(inputs)
	if (locale === "es-419") return es_419_invite_already_invited(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_already_invited(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_already_invited(inputs)
	if (locale === "de-DE") return de_de2_invite_already_invited(inputs)
	if (locale === "it-IT") return it_it2_invite_already_invited(inputs)
	return en_us2_invite_already_invited(inputs)
});
export { invite_already_invited as "invite.already_invited" }